import { decorate, observable } from 'mobx';
import receiptsModel from 'models/receipts';

class ReceiptsUploader {
  constructor() {
    this.files = observable.map({});
  }

  set(key, presignedUrls) {
    receiptsModel.add('unmatched', key, {
      date: Date.now(),
      presignedUrls
    }, true);

    this.files.delete(key);
  }
}

decorate(ReceiptsUploader, {
  files: observable
});

export default new ReceiptsUploader();
